type Props = {
  videoId: string;
  width: number | string;
  height: number | string;
  title: string;
  autoPlay?: boolean;
};

const VimeoEmbed: React.FC<Props> = ({ videoId, width, height, title, autoPlay = false }) => {
  return (
    <div className="video-container" style={{ width, height }}>
      <iframe
        width={width}
        height={height}
        src={`https://player.vimeo.com/video/${videoId}${autoPlay ? '?autoplay=1' : ''}`}
        title={title}
        style={{ border: 0 }}
        allow="autoplay; fullscreen; picture-in-picture; accelerometer; gyroscope;"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default VimeoEmbed;
